import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { MappingGroup } from "../models/mappingGroup.model";
import { GridService } from "../shared/grid/grid.service";

@Injectable({
  providedIn: "root",
})
export class MappingGroupService extends GridService<MappingGroup> {
  constructor(http: HttpClient) {
    super("MappingGroup", http);
  }
}
